import { getEnvVar } from '@psyomics/ui-common';

const prodLikeEnvironments = ['staging', 'prod', 'uat'];

type Config = {
  debugLogsEnabled: boolean;
  environment: string;
  patientApiClientId: string;
  patientApiCognitoDomain: string;
  patientApiUrl: string;
  postHogApiKey: string;
  postHogHost: string;
  sentryDsn: string;
};

const getConfig = (): Config => {
  const environment = getEnvVar('VITE_ENVIRONMENT');
  const debugLogsEnabled = !prodLikeEnvironments.includes(environment);
  const patientApiClientId = getEnvVar('VITE_PATIENT_API_CLIENT_ID');
  const patientApiCognitoDomain = getEnvVar('VITE_PATIENT_API_COGNITO_DOMAIN');
  const patientApiUrl = getEnvVar('VITE_PATIENT_API_URL');
  const postHogApiKey = getEnvVar('VITE_POSTHOG_API_KEY');
  const postHogHost = getEnvVar('VITE_POSTHOG_HOST');
  const sentryDsn = getEnvVar('VITE_PATIENT_PORTAL_SENTRY_DSN');

  return {
    debugLogsEnabled,
    environment,
    patientApiClientId,
    patientApiCognitoDomain,
    patientApiUrl,
    postHogApiKey,
    postHogHost,
    sentryDsn,
  };
};

export type { Config };
export { getConfig, prodLikeEnvironments };
